<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row">
                <div class="col-md-10">
                    <h6>Exámenes</h6>
                </div>
                <div class="col-md-2">
                    <argon-button
                    class="mt-4"
                    variant="gradient"
                    color="info"
                    fullWidth
                    size="xs"
                    @click="toCreate"
                    >Agregar Nuevo</argon-button> 
                </div>
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Clasificación</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Código</th>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >Nombre</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Tipo de muestra</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(
                            {
                                id,
                                clasification,
                                code,
                                description,
                                type,
                                color
                            },
                            index
                            ) of tests"
                            :key="index"
                        > 
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div>
                                    
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{ clasification }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div>
                                    
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{ code }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                            <p class="text-xs font-weight-bold mb-0">{{ description }}</p>
                            </td>
                            <td class="align-middle text-center text-sm">
                                <span :class="'badge badge-sm bg-gradient-'+color" >{{type}}</span>
                            </td>
                            <td class="align-middle">
                            <a
                                :href="'edit-test/'+id"
                                class="btn bg-gradient-info"
                                data-toggle="tooltip"
                                data-original-title="Edit user"
                            ><i class="fa fa-edit text-white text-sm opacity-10"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
  
<script>
import ArgonButton from "@/components/ArgonButton.vue";

export default {
    name: "tests-table",
    props: {
        tests: {
            clasification:String,
            id: Number,
            code: String,
            description: String,
            type: String,
            instructions: String, 
            color:String
        },
    },
    components: { ArgonButton },
    methods:{
        toCreate(){
            this.$router.push('/create-test')
        },
    }
};
</script>
  